module.exports = __webpack_public_path__ + "static/5-c72cb111a2aea6defaf1077c213d2121.jpg";